import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Typography } from '@mui/material';

import { PAYMENT_STATUS } from '../../shared/paymentStatus';
import {
  StyledPaymentStatusBlockedLabel,
  StyledPaymentStatusCancelledLabel,
  StyledPaymentStatusInfoLabel,
  StyledPaymentStatusSuccessLabel,
} from './PaymentDetails.styled';

export default function PaymentStatus(props) {
  const { status } = props;

  switch (status) {
    case PAYMENT_STATUS.PAID:
    case PAYMENT_STATUS.REFUNDED:
      return (
        <StyledPaymentStatusSuccessLabel>
          <Typography variant="legalTexts" color="success">
            <FormattedMessage id={`payment_status.${status}`} />
          </Typography>
        </StyledPaymentStatusSuccessLabel>
      );
    case PAYMENT_STATUS.EXPORTED:
    case PAYMENT_STATUS.EXPORTABLE:
    case PAYMENT_STATUS.UPCOMING:
    case PAYMENT_STATUS.REFUNDABLE:
      return (
        <StyledPaymentStatusInfoLabel>
          <Typography variant="legalTexts" color="info">
            <FormattedMessage id={`payment_status.${status}`} />
          </Typography>
        </StyledPaymentStatusInfoLabel>
      );
    case PAYMENT_STATUS.BLOCKED:
    case PAYMENT_STATUS.FAILED:
      return (
        <StyledPaymentStatusBlockedLabel>
          <Typography variant="legalTexts" color="error">
            <FormattedMessage id={`payment_status.${status}`} />
          </Typography>
        </StyledPaymentStatusBlockedLabel>
      );
    case PAYMENT_STATUS.CANCELLED:
      return (
        <StyledPaymentStatusCancelledLabel>
          <Typography variant="legalTexts" color="error">
            <FormattedMessage id={`payment_status.${status}`} />
          </Typography>
        </StyledPaymentStatusCancelledLabel>
      );
    default:
      return null;
  }
}
